module.exports = __webpack_public_path__ + "static/media/Estetoscopio.62519d86.svg";